export const ROLES = {
  ADMIN: 'admin',
  MEMBER: 'member',
};

export const ROLE_LABELS = {
  admin: 'Admin',
  member: 'Member',
};

export function isAdminRole(role) {
  return role === ROLES.ADMIN;
}
